module.exports = __webpack_public_path__ + "img/ico-filter-active.debcf67d.svg";